(function() {
  let counter = 0;
  let counter_de = 0;

  const URL = "https://fr.roble.store";
  const Text1 = 'FR';
  const Text2 = 'Français';
  const CODE = 'fr';

  const URL_DE = "https://de.roble.store";
  const Text1_DE = 'DE';
  const Text2_DE = 'Deutsch';
  const CODE_DE = 'de';

  const hasAlternateFr = typeof alternateLinks !== 'undefined' && alternateLinks.fr;
  const hasAlternateDe = typeof alternateLinks !== 'undefined' && alternateLinks.de;

  const new_link_url = hasAlternateFr ? alternateLinks.fr : URL;
  const new_link_url_de = hasAlternateDe ? alternateLinks.de : URL_DE;



  document.addEventListener('DOMContentLoaded', function() {
    const alternate_fr = document.querySelectorAll('link[rel="alternate"][hreflang="fr"]');

    alternate_fr.forEach(function(link) {
      link.href = new_link_url;
    });

    const alternate_de = document.querySelectorAll('link[rel="alternate"][hreflang="de"]');

    alternate_de.forEach(function(link) {
      link.href = getFullPathLink(new_link_url_de, 'de');
    });
  });

  if (!Weglot) return;

  Weglot.on('switchersReady', onSwitchersReady);

  const makeFrLink = (wrapper) => {
    let from = 'en';
    if (counter > 3) {
      return null;
    }
    let templateEn = wrapper.querySelector(`#weglot-listbox #wg-${from}`);
    if (!templateEn) {
      from = 'es';
      templateEn = wrapper.querySelector(`#weglot-listbox #wg-${from}`);
      if (!templateEn) {
        return null;
      }
    }

    const templateFr = templateEn.cloneNode();
    const enAttributes = templateEn.attributes;
    for (var i = enAttributes.length - 1; i >= 0; i--) {
      const name = enAttributes[i].name;
      const value = enAttributes[i].value;
      if (value.includes(from)) {
        templateFr.setAttribute(name, value.replace(from, CODE));
      }
    }

    const html = templateEn.innerHTML
      .replace(/(en|gb|es)/g, CODE)
      .replace('EN', Text1)
      .replace('ES', Text1)
      .replace('English', Text2)
      .replace('Español', Text2);
    templateFr.innerHTML = html;
    templateFr.querySelector(`#weglot-language-${CODE}`).href = URL;
    wrapper.querySelector('#weglot-listbox').prepend(templateFr);
    counter++;
    return wrapper.querySelector(`#weglot-language-${CODE}`)
  }

  const makeDeLink = (wrapper) => {
    let from = 'en';
    if (counter_de > 3) {
      return null;
    }
    let templateEn = wrapper.querySelector(`#weglot-listbox #wg-${from}`);
    if (!templateEn) {
      from = 'es';
      templateEn = wrapper.querySelector(`#weglot-listbox #wg-${from}`);
      if (!templateEn) {
        return null;
      }
    }

    const templateDe = templateEn.cloneNode();
    const enAttributes = templateEn.attributes;
    for (var i = enAttributes.length - 1; i >= 0; i--) {
      const name = enAttributes[i].name;
      const value = enAttributes[i].value;
      if (value.includes(from)) {
        templateDe.setAttribute(name, value.replace(from, CODE_DE));
      }
    }

    const html = templateEn.innerHTML
      .replace(/(en|gb|es)/g, CODE_DE)
      .replace('EN', Text1_DE)
      .replace('ES', Text1_DE)
      .replace('English', Text2_DE)
      .replace('Español', Text2_DE);
    templateDe.innerHTML = html;
    templateDe.querySelector(`#weglot-language-${CODE_DE}`).href = URL_DE;

    const listbox = wrapper.querySelector('#weglot-listbox');
    const frItem = wrapper.querySelector('#wg-fr');

    if (frItem && frItem.parentNode === listbox) {
      frItem.insertAdjacentElement('afterend', templateDe);
    } else {
      listbox.prepend(templateDe);
    }

    counter_de++;
    return wrapper.querySelector(`#weglot-language-${CODE_DE}`)
  }

  function getLinkInSwitcher(weglotWrapper, lang = CODE) {
    if (!weglotWrapper) return null;
    const link = weglotWrapper.querySelector(`#weglot-language-${lang}`);

    if (link) {
      return link;
    }

    if (lang === CODE_DE) {
      return makeDeLink(weglotWrapper);
    }

    return makeFrLink(weglotWrapper);
  }

  // Because Weglot triggers the switchersReady event before the switchers are actually ready
  // we need to check if the switchers are contain links
  function onSwitchersReady() {
    const { switchers } = Weglot.options;
    if (!switchers) return;
    switchers.forEach(function(sw) {
      const selector = sw.location.target;

      const weglotWrapper = document.querySelector(selector);

      const weglot_link_fr = getLinkInSwitcher(weglotWrapper, 'fr');
      if (weglot_link_fr) {
        replaceSwitchersLink(weglot_link_fr, new_link_url, 'fr');
      } else {
        const switcher_observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const weglot_link_fr = getLinkInSwitcher(weglotWrapper, 'fr');
              replaceSwitchersLink(weglot_link_fr, new_link_url, 'fr');
              switcher_observer.disconnect();
            }
          });
        });

        switcher_observer.observe(weglotWrapper, {
          childList: true,
          subtree: true
        });
      }

      const weglot_link_de = getLinkInSwitcher(weglotWrapper, 'de');
      if (weglot_link_de) {
        replaceSwitchersLink(weglot_link_de, new_link_url_de, 'de');
      } else {
        const switcher_observer_de = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const weglot_link_de = getLinkInSwitcher(weglotWrapper, 'de');
              replaceSwitchersLink(weglot_link_de, new_link_url_de, 'de');
              switcher_observer_de.disconnect();
            }
          });
        });

        switcher_observer_de.observe(weglotWrapper, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  function getFullPathLink(link, lang) {
    if (!link) return link;

    // FR has no redirects, so keep homepage unless alternateLinks.fr exists
    if (lang === 'fr') {
      return link;
    }

    // If later you create exact manual DE mappings via alternateLinks.de,
    // use that exact mapped URL without adding the Spanish path.
    if (lang === 'de' && hasAlternateDe) {
      return link;
    }

    // DE has redirects, so send user to the same clean Spanish path on DE domain
    if (lang === 'de') {
      return link.replace(/\/$/, '') + getCleanPathForRedirect();
    }

    return link;
  }

  function getCleanPathForRedirect() {
    const path = window.location.pathname;

    // Normalize Shopify product URLs:
    // /collections/collection-handle/products/product-handle
    // becomes:
    // /products/product-handle
    if (path.includes('/products/')) {
      const productHandle = path.split('/products/')[1].split('/')[0];
      return '/products/' + productHandle;
    }

    // Keep collections, pages, blogs, blog posts, policies as-is.
    // Query params like ?variant=... are intentionally not included.
    return path;
  }

  function replaceSwitchersLink(link, new_link_url, lang) {
    new_link_url = getFullPathLink(new_link_url, lang);
    if (!link || !new_link_url) return;

    link.href = new_link_url;

    // Because Weglot switchers are loaded with empty href attribute and then updated
    // we need to observe the link to update it when it changes
    const link_observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
          if (mutation.target.href !== new_link_url) {
            mutation.target.href = new_link_url;
            link_observer.disconnect();
          }
        }
      });
    });

    link_observer.observe(link, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['href']
    });
  }
})();
